import { AdminFilterChips } from "@/components/admin";

interface QuickFiltersProps {
  activeFilter: string;
  onFilterChange: (key: string) => void;
}

const quickFilterChips = [
  { key: "all", label: "전체" },
  { key: "normal", label: "정상" },
  { key: "warning", label: "확인 필요" },
  { key: "stale", label: "지연" },
  { key: "empty", label: "미수신" },
  { key: "permission", label: "권한 확인" },
  { key: "provider", label: "제공자 확인" },
];

const QuickFilters = ({ activeFilter, onFilterChange }: QuickFiltersProps) => {
  return <AdminFilterChips chips={quickFilterChips} activeKey={activeFilter} onChange={onFilterChange} />;
};

export default QuickFilters;
